
import { Component, Prop, Watch } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import SkillAssessmentTree from './SkillAssessmentTree.vue';
import ManualPassModal from './ManualPassModal.vue';
import { SchemeNodeModel } from '@/models/schemeNodeModel';
import { GroupSchemeScope } from '@/components/mixins/schemescope';
import { findManualButtonNode, nodeRequirementsMet } from '@/services/utils';
import { GroupScope } from '@/components/mixins/groupscope';
import _difference from 'lodash/difference';
import { Member } from '@/models/member';

@Component({
  components: {
    SkillAssessmentTree,
    ManualPassModal,
  },
  name: 'SkillAssessment',
})
export default class SkillAssessment extends mixins(GroupSchemeScope, GroupScope) {
  /**
   * selectedNodeId
   * Level node selected from the menu of levels relevant to the chosen group.
   *
   * @private
   * @property {string}
   */
  @Prop() public selectedNodeId!: string;
  @Prop() public directLinkNodeId!: SchemeNodeModel;
  @Prop({ default: false }) public completeOnly!: boolean;

  public showManualPassModal = false;
  public showAllMembers = true;
  public showAllMembersSwitch = false;

  created() {
    this.$store.dispatch('nav/calculateStyle', { schemeNodeId: '', schemeSlug: this.slug, updateTheme: true });
    // For BG restrict gymnasts shown by their progress and show switch allowing them to see all
    if (this.groupLevels === null) {
      this.showAllMembers = false;
      this.showAllMembersSwitch = true;
    }
  }

  /**
   * Computed getter for returning the selected scheme node to assess.
   * This will be passed in from the menu links and will be a level node.  We need to pass the selected level into
   * skill assessment tree so we can build assessment nodes for relevant members from it's children.
   *
   * @return {SchemeNodeModel}
   */
  get selectedNode(): SchemeNodeModel {
    return this.getNode(this.selectedNodeId);
  }

  get parentNode(): SchemeNodeModel | null {
    return this.selectedNode.parentId ? this.getNode(this.selectedNode.parentId) : null;
  }

  get manualLevelPassableMembers(): Array<Member> {
    // if the level is manual and passable, and unpassed for each member
    const button = findManualButtonNode(this.selectedNode);
    return this.groupMembers.filter(
      member =>
        button &&
        nodeRequirementsMet(button.dependencies, member.assessments.complete) &&
        !(member.assessments.complete && member.assessments.complete[button.id] === true)
    );
  }

  @Watch('manualLevelPassableMembers')
  showManualLevelPopup(value: Array<Member>, previousVal: Array<Member>) {
    // we show the popup if there is at least one new member in the array now
    if (
      _difference(
        value.map(m => m.uuid),
        previousVal.map(m => m.uuid)
      ).length > 0
    ) {
      this.showManualPassModal = true;
    }
  }
}
